const Logo = ({ size = 32 }: { size?: number }) => (
  <img
    src="/sealcoatpaving_enterprise_brand_system/01_masters/0E8A8A62-4415-49B7-B3E0-E77BEDA3BF0F.png"
    alt="SealcoatPaving official company logo"
    className="block w-auto shrink-0 object-contain"
    style={{ height: size }}
    decoding="async"
  />
)

export default Logo